export const STYLES = {
  tables: {
    container:
      "tw-flex tw-flex-col tw-w-full tw-shadow-3x2 tw-bg-simple-10 tw-py-3.5 tw-px-8 tw-m-px sm:tw-flex-row sm:tw-justify-between sm:tw-flex-wrap tw-gap-2",
    title: "tw-flex tw-items-center tw-w-fit tw-m-0 tw-font-normal tw-text-2xl",
    actions: {
      container:
        "tw-flex tw-flex-col sm:tw-flex-row sm:tw-justify-start sm:tw-flex-wrap tw-gap-1 lg:tw-gap-3",
      filter: "tw-w-full sm:tw-w-auto tw-h-10",
      requestFinantiation:
        "!tw-bg-primary hover:!tw-bg-primary-over tw-flex-1 sm:tw-w-52 tw-h-10",
      simple:
        "!tw-bg-white !tw-border-primary !tw-text-primary !tw-border-solid tw-w-full sm:tw-w-auto tw-h-10",
      create:
        "!tw-bg-secondary !tw-border-none tw-w-full sm:tw-w-auto tw-h-10 hover:!tw-bg-secondary-over",
    },
  },
}
